import { render, staticRenderFns } from "./ExamEditDialog.vue?vue&type=template&id=5a44890c&scoped=true"
import script from "./ExamEditDialog.vue?vue&type=script&lang=js"
export * from "./ExamEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamEditDialog.vue?vue&type=style&index=0&id=5a44890c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44890c",
  null
  
)

export default component.exports